import request, {requestJson} from '../main';
const service = ""
class LogApi {
    private url: string = service + "/operation-log";

    public pageList(args: any){
        return request({
            url: this.url + '/page-list',
            method: 'get',
            params: args
        })
    }

    public delLog(args: any){
        return request({
            url: this.url + '/del-log',
            method: 'post',
            data: args
        })
    }
}

const logApi = new LogApi();
export default logApi;
